import Attribute from "./Attribute";

class ObjectAttribute extends Attribute {
    constructor(name, def) {
        super(name, def);
        this.type = 'object';
    }

    fromJson(data) {
        return data;
    }

    toJson(value) {
        return value;
    }
}

export default ObjectAttribute;